// extracted by mini-css-extract-plugin
export default {"menuButton":"toggleMenu_menuButton__hcfM+","span":"toggleMenu_span__teXqX","searchbar":"toggleMenu_searchbar__8PYAU","toggleMenu":"toggleMenu_toggleMenu__Rs4MJ"};